export default __webpack_public_path__ + "images/046d566120013ceb4c787f5dd9fff297.svg";